import React from "react";
import './style.less';
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
import { Row, Col } from 'antd'

export default class AboutUs extends React.Component {
    render() {
        return (
            <div className={'about-us'}>
                <div className={"title"}>
                    <Texty
                        mode="random"
                    >
                        关于我们
                    </Texty>
                </div>
                <div className={"about-desc"}>
                    <p>
                        力动几何位于中国成都，成立于2017年。公司致力于研发和生产高效电动飞机，主要应用于数据采集、监控、货运和载人运输。
                    </p>
                        <div className="split-line"></div>
                    <p>
                        力动几何由一个专业的飞机技术团队创立。我们的团队从自主研发起步，掌握着飞机的核心气动设计和制造，包括复合核心材料、机械化量产，直到最后的成型、装配和测试。
                        </p>
                        <div className="split-line"></div>

                    <p>
                        通过卓越质量监控、成本控制和高效的生产能力，P系列垂直起降无人机目前打破了 25 公斤以下垂直起降电动飞机的世界纪录。已广泛应用于测绘、安防、应急、巡检等领域。 尤其受到国际市场上各国军警客户的青睐。
                    </p>
                </div>
                <div className={'about-desc1'}>
                    <div className={'about-line1'}>
                        <Row justify="center">
                            <Col xs={24} sm={24} md={8} lg={8} xl={8} className="line1">
                                成立于 <span>2017</span>年
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8} className="line1">
                                研发 <span>3</span> 年
                            </Col>
                        </Row>
                    </div>
                    <div className={'about-line2'}>
                        <Row>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="line1">
                                <span>2000+ </span>次测试
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="line1">
                                事故率低于 <span>1/1000</span>
                            </Col>
                        </Row>
                    </div>
                    <div className={'branding'}>
                        <div className={'title'}>
                            我们的目标
                        </div>
                        <Row justify="center">
                            <Col xs={20} sm={16} md={16} lg={12} xl={12}>
                                <div className={"brand-desc"}>
                                    <div className={"brand-line"}>
                                        <div className={"brand-line-top"}>
                                            我们在做什么？
                                        </div>
                                        <div className={"brand-line-bottom"}>
                                            我们致力于开发一个全新的空中生态运输系统，我们相信未来的空中空间将像道路交通一样繁荣。
                                        </div>
                                    </div>
                                    <div className={"brand-line"}>
                                        <div className={"brand-line-top"}>
                                            为什么是垂直起降电动飞机？
                                        </div>
                                        <div className={"brand-line-bottom"}>
                                            我们相信清洁和可再生能源的光明未来，我们相信飞机可以使用绿色环保的能源翱翔于天空。</div>
                                    </div>
                                    <div className={"brand-line"}>
                                        <div className={"brand-line-top"}>
                                            如何实现我们的目标？
                                        </div>
                                        <div className={"brand-line-bottom"}>
                                            我们专注于为客户提供解决方案、高度可靠的产品和高效的技术，为我们的未来奠定坚实的基础。</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        )
    }
}
